export const getCitiesByQuery = state => state.byQuery || {}
